import React, { ComponentProps, useCallback } from 'react';

import A from '@adsk/alloy-react-a';
import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

import PlanTaskEntityBlockAssigneeSummary from './PlanTaskEntityBlockAssigneeSummary/PlanTaskEntityBlockAssigneeSummary';
import PlanTaskEntityBlockDateSummary from './PlanTaskEntityBlockDateSummary/PlanTaskEntityBlockDateSummary';
import PlanTaskEntityBlockHeader from './PlanTaskEntityBlockHeader/PlanTaskEntityBlockHeader';
import PlanTaskEntityBlockStatusSummary from './PlanTaskEntityBlockStatusSummary/PlanTaskEntityBlockStatusSummary';
import { PlanTaskAnalyticEvent } from '../../consts';
import { trackPlanTaskEvent } from '../../helpers';
import { usePlanTaskLink } from '../../hooks';
import { PlanTaskReferencePickerPlugin } from '../../types';
import PlanTaskContextPath from '../PlanTaskContextPath/PlanTaskContextPath';

type PlanTaskEntityBlockProps = ComponentProps<
  PlanTaskReferencePickerPlugin['EntityBlock']
>;

const PlanTaskEntityBlock = ({
  entity: { task },
  sourceEntityType,
  onRemoveClick,
  onReferenceClickAnalytics,
}: PlanTaskEntityBlockProps) => {
  const planTaskLink = usePlanTaskLink(task);

  const onClick = useCallback(() => {
    if (sourceEntityType) {
      trackPlanTaskEvent(PlanTaskAnalyticEvent.VIEW, sourceEntityType);
    }

    onReferenceClickAnalytics?.();
  }, [sourceEntityType, onReferenceClickAnalytics]);

  return (
    <A
      href={planTaskLink}
      onClick={onClick}
      target="_blank"
      style={{
        cursor: 'pointer',
        [`&:hover .PlanTaskPlugin__remove`]: {
          visibility: 'visible',
        },
      }}
    >
      <Flex
        flexDirection="column"
        padding="12px 16px"
        color="charcoal900"
        borderBottom={`1px solid ${theme.colors.charcoal100}`}
        position="relative"
        overflow="hidden"
        style={{ gap: '8px' }}
      >
        <PlanTaskEntityBlockHeader task={task} onRemoveClick={onRemoveClick} />
        <PlanTaskEntityBlockDateSummary task={task} />
        <PlanTaskEntityBlockStatusSummary task={task} />
        <PlanTaskEntityBlockAssigneeSummary task={task} />
        <PlanTaskContextPath task={task} />
      </Flex>
    </A>
  );
};

export default PlanTaskEntityBlock;
